import React from 'react';

import { Item, Link, Button, Label, Icon } from './styles';

type Props = {
  label: string;
  to?: string;
  onClick?(event: React.MouseEvent<HTMLButtonElement>): void;
};

const MenuListItem = ({ label, to, onClick }: Props) => (
  <Item>
    {to ? (
      <Link to={to}>
        <Label>{label}</Label>
        <Icon src="/corporate/images/chevron-right.svg" aria-hidden />
      </Link>
    ) : (
      <Button onClick={onClick}>
        <Label>{label}</Label>
        <Icon src="/corporate/images/chevron-right.svg" aria-hidden />
      </Button>
    )}
  </Item>
);

export default MenuListItem;
